import { PoliciesAddDetailChecksPage } from "~/pages/shared/policy/PoliciesAddDetailChecksPage";

export function PlatformPoliciesAddDetailChecksPage() {
  return <PoliciesAddDetailChecksPage basePath="/policies" />;
}
